import LazyLoad from 'vanilla-lazyload';

$(function() {
    const lazyLoadInstance = new LazyLoad({
        use_native: true
    });
    if (typeof window !== 'undefined') {
        window.__lazyLoadInstance = lazyLoadInstance;
    }
});
